import React, { useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Draft } from "./productRecipeEditor";
import RecipeFieldError, {
  RecipeErrors,
  recipeFieldProps,
} from "./RecipeFieldError";
import { control } from "./recipeStyles";
interface Props {
  notes: string;
  disabled: boolean;
  errors: RecipeErrors;
  change: (values: Partial<Draft>) => void;
}
export default function RecipeNotes({
  notes,
  disabled,
  errors,
  change,
}: Props) {
  const [notesOpen, setNotesOpen] = useState(Boolean(notes));
  return (
    <details
      className="group rounded-lg border border-slate-200"
      open={notesOpen || Boolean(errors.notes)}
      onToggle={(event) => setNotesOpen(event.currentTarget.open)}
    >
      <summary className="flex min-h-[44px] cursor-pointer list-none items-center gap-2 px-4 py-3 text-sm font-medium text-slate-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500">
        <ChevronDownIcon
          className="h-4 w-4 text-slate-400 transition group-open:rotate-180"
          aria-hidden="true"
        />
        Preparation notes
        <span className="ml-auto text-xs font-normal text-slate-400">
          {notes ? "Added" : "Optional"}
        </span>
      </summary>
      <div className="px-4 pb-4">
        <label htmlFor="recipe-notes" className="sr-only">
          Preparation notes (optional)
        </label>
        <textarea
          id="recipe-notes"
          rows={2}
          maxLength={10000}
          value={notes}
          disabled={disabled}
          onChange={(event) => change({ notes: event.target.value })}
          className={control}
          placeholder="Mixing instructions, preparation steps…"
          {...recipeFieldProps("notes", errors)}
        />
        <RecipeFieldError field="notes" errors={errors} />
      </div>
    </details>
  );
}
